import { REACT_APP_LANGUAGE_CHANGE_ENABLE } from "config/environment"

const constants = {
    defaultAge: 21,
    appRefreshTime: 300000,
    bestSellersId: '48436',
    final_statuses: ['delivered', 'canceled', 'picked_up', 'returned'],
    in_progress_statuses: ['complete', 'out_for_delivery', 'in_progress', 'ready', 'submitted','preorder'],
    staticRoutes: [
        'home',
        'shop',
        'deals',
        'orders',
        'order-details',
        'checkout',
        'order-status',
        'search-results',
        'user-account',
        'referafriend',
        '7NowGoldPass',
        'FAQs',
        'contact-us',
        'drawer-account',
        'drawer-basket',
        'catering',
        '',
    ],
    paypal: 'paypal',
    venmo: 'venmo',
    // braintree: 'braintree',
    stripe: 'stripe',
    applePay: 'Apple Pay',
    googlePay: 'Google Pay',
    monthly: 'monthly',
    failure_statuses: ['failed', 'canceled'],
    subscription_active: 'active',
    subscription_suspended: 'suspended',
    subscription_canceled: 'canceled',
    subscription_trial: 'trial',
    fetchOrdersLimit: 15,
    SEARCH_LIMIT: 40,
    ADDRESS_MAX_LIMIT: 80,
    sortTypes: ['Popularity', 'Price', 'Alphabetically'],
    appStoreURL: ' https://apps.apple.com/us/app/7now-food-alcohol-delivery/id1316244211',
    googleStoreURL: 'https://play.google.com/store/apps/details?id=com.seven.eleven.phoenix',

    // US
    appStoreSmartURLBdy:
        'https://smart.link/jtm8huqe0i5no?site_id=20201028&creative_id=bdy-download-app',
    appStoreSmartURLFtr:
        'https://smart.link/jtm8huqe0i5no?site_id=20201028&creative_id=ftr-download-app',
    downloadAppFromRewards:
        'https://smart.link/jtm8huqe0i5no?site_id=20210301&creative_id=app-view-dld',
    accountsPageRewards:
        'https://smart.link/jtm8huqe0i5no?site_id=20210301&creative_id=get-the-app',
    productDetailsURLBdy:
        'https://smart.link/jtm8huqe0i5no?site_id=20201028&creative_id=bdy-prd-dld-app',
    appDownloadURLBdy:
        'https://smart.link/jtm8huqe0i5no?site_id=20201028&creative_id=site-dwn-dld-app',

    // CA
    appStoreSmartCanadaURLBdy:
        'https://smart.link/29uce5jhpernf?site_id=site-050421&creative_id=ca-bdy-download-app',
    appStoreCanadaSmartURLFtr:
        'https://smart.link/29uce5jhpernf?site_id=site-050421&creative_id=ca-ftr-download-app',
    downloadCanadaAppFromRewards:
        'https://smart.link/29uce5jhpernf?site_id=site-050421&creative_id=ca-app-view-dld',
    accountsPageCanadaRewards:
        'https://smart.link/29uce5jhpernf?site_id=site-050421&creative_id=ca-get-the-app',
    productDetailsCanadaURLBdy:
        'https://smart.link/29uce5jhpernf?site_id=site-050421&creative_id=ca-bdy-prd-dld-app ',
    appDownloadCanadaURLBdy:
        'https://smart.link/29uce5jhpernf?site_id=site-050421&creative_id=ca-site-dwn-dld-app',

    // TO DO : Remove the below items from here
    categoriesCountToShow: 4,
    maxCategoriesToShowHomePage: 6,
    enterDeliveryAddressStep: 1,
    confirmDeliveryAddressStep: 2,
    createAccountStep: 3,
    enterPickUpAddressStep: 1,
    confirmPickUpAddressStep: 2,
    uiBreadCrumbsStringMap: new Map(
        Object.entries({
            home: true,
            shop: true,
            deals: true,
            checkout: true,
            recentlyboughtitems: true,
            'order-status': true,
            'user-account': true,
            'order-details': true,
        })
    ),
    customerSupportNumber: '+1 808-944-2711',

    // Path to the fallback image for products
    fallbackImagePath: 'assets/images/productFallbackImage.png',

    // Fallback for store operational hours/days
    fallBackStoreOperational : {
        "workingDays": [
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat",
            "Sun"
        ],
        "workingHours": {
            "from": "10:00",
            "to": "18:00"
        }
    },
    minLeadTime:2,
    maxLeadTime:14,
    isLanguageChangeEnabled:REACT_APP_LANGUAGE_CHANGE_ENABLE || 'false',
    DEFAULT_TIMEZONE: 'Pacific/Honolulu'
}

export default constants
